import { mapEnumToOptions } from '@abp/ng.core';

export enum TrayShipmentStatus {
  Dispatch = 0,
  Accepted = 1,
  Edited = 2,
  Canceled = 3,
}

export const trayShipmentStatusOptions = mapEnumToOptions(TrayShipmentStatus);
